import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as usersActions from '../../actions/users';
import {applicationMessage} from '../../actions/application';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({applicationMessage, ...usersActions}, dispatch);
}

function mapStateToProps(store) {
    return {
        users : store.users,
        territories : store.territories,
        coordinations : store.coordinations,
        session : store.session,
    }
}

class Users extends React.Component {
    render() {
        return React.cloneElement(this.props.children, this.props);        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);


/** WEBPACK FOOTER **
 ** ./src/components/containers/Users.jsx
 **/